import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/date.default.js
// module id = ./node_modules/lodash-es/date.default.js
// module chunks = common